module.exports = __webpack_public_path__ + "img/icon_ke+ks+ksvipslt.d6456cae.png";